module.exports = __webpack_public_path__ + "img/blog-abstract.0cb3f43.svg";